import { FC } from 'react';
import intl from 'react-intl-universal';
import { tailwindOverride, Icon } from '@getsynapse/design-system';
import { resolveSchedule, fmtDateLong } from './utils';
import { useLanguage } from 'Organisms/LanguageModal/LanguageContext';
import CalendarIcon from 'assets/icons/calendar.svg';

interface SchedulePreviewProps {
  startDay: string;
  duration: string;
}

const ALLOWED_DATE_LOCALES: Record<string, string> = {
  en: 'en-US',
  fr: 'fr-CA',
};
const SAMPLE_PROJECT_START = new Date(2026, 5, 1); // Mon, Jun 1 2026

const SchedulePreview: FC<SchedulePreviewProps> = ({ duration, startDay }) => {
  const dur = Math.max(1, +duration || 1);
  const off = Math.max(0, +startDay || 0);
  const { start, end } = resolveSchedule(off, dur, SAMPLE_PROJECT_START);
  const { currentLocale } = useLanguage();
  const dateLocale = ALLOWED_DATE_LOCALES[currentLocale];

  return (
    <aside
      className={tailwindOverride(
        'flex flex-col gap-y-1 rounded px-6 py-4',
        'border border-secondary-lightest bg-secondary-lightest-two'
      )}
      aria-labelledby='timeline-example-title'
    >
      <div className='flex gap-x-1 items-center' id='timeline-example-title'>
        <Icon
          src={CalendarIcon}
          className='fill-current text-secondary-darker text-xl'
          aria-hidden
        />
        <span className='text-base text-secondary-dark font-medium'>
          {intl.get(
            'SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUILD_SECTION.TIMELINE.SCHEDULE_PREVIEW.TITLE'
          )}
        </span>
      </div>
      <div className='flex flex-col gap-y-1'>
        <span
          className='text-sm text-secondary-darker'
          aria-live='polite'
          id='timeline-example-text'
        >
          {intl.getHTML(
            'SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUILD_SECTION.TIMELINE.SCHEDULE_PREVIEW.DESCRIPTION',
            {
              project: fmtDateLong(SAMPLE_PROJECT_START, dateLocale),
              dur,
              off,
              start: fmtDateLong(start, dateLocale),
              end: fmtDateLong(end, dateLocale),
            }
          )}
        </span>
        <span
          className='text-xs text-secondary-darker'
          id='timeline-example-note'
        >
          {intl.getHTML(
            'SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUILD_SECTION.TIMELINE.SCHEDULE_PREVIEW.NOTE'
          )}
        </span>
      </div>
    </aside>
  );
};

export default SchedulePreview;
